import config from "../config";

export const determineImage = hit => {
  const filestackRequestUrl = `https://process.filestackapi.com/resize=h:124,w:248,fit:crop/`;
  if (!hit || (!hit.bannerImage && !hit.socialImage && !hit.featureImage)) {
    return filestackRequestUrl + "VbieTVjAQvq5BTkE9vIi";
  }
  if (hit.bannerImage) {
    if (typeof hit.bannerImage === "object") {
      return filestackRequestUrl + hit.bannerImage.handle;
    }
    return filestackRequestUrl + hit.bannerImage;
  }
  if (hit.socialImage) {
    return filestackRequestUrl + hit.socialImage;
  }
  if (hit.featureImage) {
    if (typeof hit.featureImage === "object") {
      return filestackRequestUrl + hit.featureImage.handle;
    }
    return filestackRequestUrl + hit.featureImage;
  }
  return filestackRequestUrl + "VbieTVjAQvq5BTkE9vIi";
};

export const determineLocation = hit => {
  if (!hit || !hit.location) {
    return "TBD";
  }
  if (typeof hit.location === "object") {
    return hit.location.address;
  }
  return hit.location;
};

export const determineDateString = hit => {
  if (
    !hit ||
    !hit.dates ||
    !hit.dates.length ||
    !hit.dates[0].display ||
    !hit.dates[0].display.date ||
    !hit.dates[0].display.time
  ) {
    return "TBD";
  }
  return `${hit.dates[0].display.date}, ${hit.dates[0].display.time}`;
};

export const determingLink = hit => {
  let link = "";
  const ticketingURL =
    hit && hit.localeData && hit.localeData.ticketURL
      ? hit.localeData.ticketURL
      : "https://events.humanitix.com.au";
  if (hit.ticketingLink) {
    link = hit.ticketingLink;
    if (hit.ticketingLink.includes("http://localhost:3000")) {
      link = link.replace("http://localhost:3000", ticketingURL);
    }
  } else {
    link = `${ticketingURL}/${hit.slug}`;
  }
  return link;
};
